// pages/HomePage.jsx
import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Banner from "../components/Banner";
import Header from "../components/Header";
import Nav from "../components/Nav";
import About from "../components/About";
import Skills from "../components/Skills";
import Projects from "../components/Projects";
import Interests from "../components/Interests";
import Footer from "../components/Footer";
import Experience from "../components/Experience1";

import LoadingPage from "../pages/LoadingPage"; // ✅ 引入加载动画
import { getSkills, getProjects, getArticles } from "../components/api"; // ✅ 引入数据方法（如有）

import AnimatedPage from "../components/AnimatedPage";

import { useScrollRestoration } from "../components/useScrollRestoration";

const HomePage = ({ toggleDarkMode, isDarkMode, pageAnimated, loading, setLoading }) => {
  const [showSkills, setShowSkills] = useState(true);
  const [direction, setDirection] = useState(1);

  useScrollRestoration();

  const handleToggle = (newDirection) => {
    setDirection(newDirection);
    setShowSkills(!showSkills);
  };

  useEffect(() => {
    // 并行加载多个模块的数据
    Promise.all([
      getSkills(),
      getProjects(),
     
    ])
      .then(([skills, projects, articles]) => {
        // 可以在这里用 context 或 props 把数据传给组件
        // 也可以等数据加载完再展示页面
        console.log({ skills, projects, articles });
      })
      .catch(console.error)
      .finally(() => setLoading(false)); // ✅ 关闭 loading 状态
  }, []);

  if (loading) return <LoadingPage />; // ✅ 正在加载时显示

  return (
    <>
      <AnimatedPage className="scrollbar-none">
        <Header toggleDarkMode={toggleDarkMode} isDarkMode={isDarkMode} />
        <div className={`${pageAnimated ? "fade-in-center" : ""}`}>
          <Banner isDarkMode={isDarkMode}/>
          <About isDarkMode={isDarkMode}/>
          <div className="relative overflow-hidden">
            <AnimatePresence mode="wait" initial={false}>
              {showSkills ? (
                <motion.div
                  key="skills"
                  initial={{ x: direction === 1 ? -1000 : 1000, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  exit={{ x: direction === 1 ? -1000 : 1000, opacity: 0 }}
                  transition={{ duration: 0.5, ease: "easeInOut" }}
                >
                  <Skills onToggle={() => handleToggle(-1)} />
                </motion.div>
              ) : (
                <motion.div
                  key="experience"
                  initial={{ x: direction === -1 ? 1000 : -1000, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  exit={{ x: direction === -1 ? 1000 : -1000, opacity: 0 }}
                  transition={{ duration: 0.5, ease: "easeInOut" }}
                >
                  <Experience onToggle={() => handleToggle(1)} isDarkMode={isDarkMode}/>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          <Projects />
          <Interests />

          <Footer toggleDarkMode={toggleDarkMode} isDarkMode={isDarkMode} />
        </div>
        <div className="hidden lg:block">
          <Nav 
            toggleDarkMode={toggleDarkMode} 
            isDarkMode={isDarkMode} 
            currentPage={showSkills ? "skills" : "experience"} 
          />
        </div>
      </AnimatedPage>
    </>
  );
};

export default HomePage;
